// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionIframe_articleMain__-p96l","iframeWrapper":"SectionIframe_iframeWrapper__a7v2b","iframe":"SectionIframe_iframe__3FUwS"};